import "../polyfill/index";
import initializeSignaturePad from '../ui/form/signature-pad';
import {importFontAwesomeCss, importFontAwesomeJavascript} from "../ui/fontawesome";
import mainColScrollFix from "./global/fixes/mainColScrollFix";
import {setUpLCSlider} from "../ui/lcMicroSlider/lc-micro-slider";
import {registerScopeFunction} from "../util/scope";
import {setUpNavOffset} from "../ui/nav-offset/nav-offset";
import {setUpDetailsSlide} from "./dataset/details-slide/details-slide";
import {setUpSpecialPriceCountdown} from "./dataset/special-price/countdown";
import {setUpCounters} from "./global/counter/counter";
import {setUpCookieConsent} from "./global/cookie-banner/cookieConsent";
import {setUpCookieBanner} from "./global/cookie-banner/cookieBanner";
import {setUpIframeCommunication} from "./global/iframe-communication/iframeCommunication";
import {setUpAllowCookieMessageHandler} from "./global/iframe-communication/message-handlers/seltmannCmsAllowCookie";
import {setUpRecaptcha} from "./global/recaptcha/recaptcha";
import {setupGoogleAdsConversionTracking} from "./global/google-ads-conversion-tracking/conversionTracking";
import {setUpDialog} from "./global/dialog/dialog";
import {setUpDatasetPopup} from "./global/dataset-popup/datasetPopup";
import {fixSubMenuPositions} from "./menu/headerNavigationMenu";
// load global functions
import './global/pop-up';

setUpIframeCommunication();
setUpAllowCookieMessageHandler();
setUpRecaptcha();
setUpCookieConsent();

registerScopeFunction(initializeSignaturePad);
registerScopeFunction(mainColScrollFix);
registerScopeFunction(setUpLCSlider);
registerScopeFunction(setUpDetailsSlide);
registerScopeFunction(setUpSpecialPriceCountdown);
setUpNavOffset();
registerScopeFunction(setUpCounters);
registerScopeFunction(setUpCookieBanner);
registerScopeFunction(setupGoogleAdsConversionTracking);
registerScopeFunction(setUpDialog);
registerScopeFunction(setUpDatasetPopup);
registerScopeFunction(fixSubMenuPositions);

importFontAwesomeJavascript().then(() => { /* do nothing */ }, () => { console.error('Failed to load fontawesome Javascript!'); });
importFontAwesomeCss().then(() => { /* do nothing */ }, () => { console.error('Failed to load fontawesome CSS!'); });
